import { render, staticRenderFns } from "./DetailSelect.vue?vue&type=template&id=7f90873c&scoped=true&"
import script from "./DetailSelect.vue?vue&type=script&lang=js&"
export * from "./DetailSelect.vue?vue&type=script&lang=js&"
import style0 from "./DetailSelect.vue?vue&type=style&index=0&id=7f90873c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f90873c",
  null
  
)

export default component.exports